export enum AppOrVersion {
  APP,
  VERSION,
}

export enum ButtonType {
  FROM_SCRATCH = 'from-scratch',
  FROM_DRAFT = 'from-draft',
  FROM_MANIFEST = 'from-manifest',
}
